// extracted by mini-css-extract-plugin
export default {"gate":"AutoplayGate_gate__wKJOK","logo":"AutoplayGate_logo__pEe65","pulse":"AutoplayGate_pulse__Hyuk4","text":"AutoplayGate_text__qilFh","fadeIn":"AutoplayGate_fadeIn__7g9Bm"};